<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <el-badge
          :value="checkedCount"
          class="export-button ml-2"
          :class="{ clearable: !!checkedCount }"
          v-if="allow('E')"
        >
          <b-button
            size="sm"
            class="export-button"
            variant="outline-success"
            :disabled="checkedCount < 1"
            @click="exportData"
          >
            <b-icon-download></b-icon-download>
            {{ $l('INDEX.btn_export') || '导出' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
      }"
      @close="closeChooseTemplate"
      @confirmClose="confirmClose"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/backstage/components/choose-template'
import { getLang } from '@/libs/util.lang'
export default {
  components: { PageHeader, PageMain, ChooseTemplate },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      checkedRow: [],
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'admin-sampleSet',
        exportParams: {
          sampleSetCodeList: [],
          language: getLang(),
        },
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sampleSetInfoListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportData() {
      const exportParams = this.$refs.main.exportData()
      if (!exportParams) {
        return
      }
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'admin-sampleSet',
        exportParams: {
          ...exportParams,
          language: getLang(),
        },
      }
    },
    closeChooseTemplate() {
      this.chooseTemplateOptions.visible = false
    },
    confirmClose() {
      this.closeChooseTemplate()
      this.$refs.main.removeCheckBox()
    },
    clearCheckboxRow() {
      this.$refs.main.removeCheckBox()
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'sample-setproofing-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.export-button {
  .el-icon-circle-close {
    display: none;
  }
}

.export-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }

  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
